<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  computed: {
    ...mapState(["USER","LANGUAGE","PAGEMAXINDEX"]),
  },
  mounted() {
    this.SAVELANGUAGE(localStorage.language || "cn")
    this.SAVEPAGEMAXINDEX(localStorage.pageMaxIndex || 0)
    this.SAVEUSER(sessionStorage.user)
    if (!this.USER || this.USER == 'undefined') {
      // this.$router.push("/login")
      this.$router.push(this.$route.query.link ? '/login?link='+this.$route.query.link : '/login')
    }
  },
  methods: {
    ...mapMutations([
      "SAVELANGUAGE",
      "SAVEUSER",
      "SAVEPAGEMAXINDEX"
    ])
  }
}
</script>

<style lang="scss" type="text/css">
  @import "common/sass/assets.css";
  @import "common/sass/index.SCSS";
</style>



// WEBPACK FOOTER //
// src/App.vue